module.exports = __webpack_public_path__ + "a69a9f63.png";